// Strings for S3. Only the S3 worker edits this file (see web/README.md).
// Copy from prototype/index.html, assets/app.js and ux-flow.md S3; DRAFT = no source there (w2-03 report).
export default {
  title: 'Find your flight',
  titleFirst: 'Your first flight: {from} → {to}',
  titleConnecting: 'Your connecting flight: {from} → {to}',
  filterLabel: 'Filter flights',
  filterPlaceholder: 'Flight number or airline (optional)',
  chipsLabel: 'Show flights', // DRAFT (accessible name of the chip group)
  'chip.delayed': 'Delayed',
  'chip.cancelled': 'Cancelled',
  'chip.all': 'All flights',
  codeshare: 'also sold as {idents}',
  showAll: '{count} more flights on this route — show all',
  showAll_one: '{count} more flight on this route — show all',
  showAll_other: '{count} more flights on this route — show all',
  cantFind: "I can't find my flight",
  searching: 'Searching for your flight…',
  'trust.free': 'Free check',
  'trust.noWinNoFee': 'No win, no fee',

  // Empty states
  emptyChip: 'No {chip} flights match on this route.',
  emptyFiltered: 'No flights match on this route.',
  emptyFilteredHint: 'Check the date and airports, or enter the flight yourself.',
  empty:
    'No flights found on this route for that date. Check the date and airports, or enter the flight manually.',
  emptyBeyondHorizon:
    "That date is further back than our flight data goes. Tell us the flight number and we'll check it with the airline.", // DRAFT
  emptyUnavailable:
    "We can't reach the flight data right now. Tell us the flight number and we'll check it as soon as we can.", // DRAFT
  searchFailed: "We couldn't load the flights just now.", // DRAFT
  tryAgain: 'Try again', // DRAFT
  saveFailed: "That didn't save. Check your connection and try again.", // DRAFT

  // Connections: later legs (ux-flow.md S3; the next day is a contract addition)
  skip: "Skip — I don't know this one",
  sameDayOn: 'Showing flights on {date}.', // DRAFT
  nextDayOn: 'Showing flights on {date}, the next day.', // DRAFT
  nextDay: 'It left the next day', // DRAFT
  sameDay: 'Back to the same day', // DRAFT

  // Status flaps (prototype FLAP_BY_STATUS) and captions (delayCaption)
  'flap.cancelled': 'CANCELLED',
  'flap.delayed': 'DELAYED',
  'flap.on_time': 'ARRIVED',
  'flap.diverted': 'DIVERTED', // DRAFT (the prototype had no diverted flights)
  'flap.pending': 'PENDING',
  'caption.cancelled': 'never arrived',
  'caption.diverted': 'landed elsewhere', // DRAFT
  'caption.pending': 'details pending',
  'caption.onTime': 'on time',
  'caption.late': 'arrived {delay} late',
  mins: '{m} min',
  hours: '{h} h',
  hoursMins: '{h} h {m} min',
} as const;
